import { cn } from '@/lib/utils';

type TextTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div' | 'span' | 'a' | 'small';

interface EGTextProps {
  tag: TextTag;
  colorClass?: string;
  href?: string;
  children?: React.ReactNode;
  className?: string;
}

const headingTags: TextTag[] = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

const tagStyles: Record<TextTag, string> = {
  h1: 'text-[2.25rem] leading-[2.625rem] font-semibold',
  h2: 'text-[2.25rem] leading-[2.75rem] font-semibold',
  h3: 'text-2xl leading-8 font-medium tracking-[-0.00875rem]',
  h4: 'text-lg leading-[1.375rem] font-medium tracking-[-0.00875rem]',
  h5: 'text-sm leading-5 font-medium tracking-[-0.00875rem]',
  h6: 'text-sm leading-5 font-medium tracking-[-0.00875rem]',
  p: 'leading-6 font-normal tracking-normal',
  div: 'leading-6 font-normal tracking-normal',
  span: 'leading-6 font-normal tracking-normal',
  a: 'leading-6 font-normal tracking-normal hover:underline',
  small: 'font-normal leading-4 tracking-[0.0125rem]',
};

export function EGText({ tag, colorClass = 'text-body', href, children, className }: EGTextProps) {
  const Tag = tag;
  const isHeading = headingTags.includes(tag);

  const combinedClassName = cn(colorClass, isHeading && 'text-heading font-serif', tagStyles[tag], className);

  if (tag === 'a') {
    return (
      <a href={href} className={combinedClassName}>
        {children}
      </a>
    );
  }

  return <Tag className={combinedClassName}>{children}</Tag>;
}

export default EGText;
